import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { useGlobalContext } from "../../Context/GlobalContext";

import axios from "axios";
import Loading from "../../Extra/Loading";

const DemandApprovalIns = ({ stationData, itemData }) => {
  const [stationId, setStationId] = useState(null);

  const createEntry = () => ({
    Sr_No: null,
    item_id: null,

    requested_qty: null,
    remarks: null,

    status: null,

    approved_qty: null,
    approved_by: null,
    document: null,

    delete: null,
  });

  const { userData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedRow, setSelectedRow] = useState(null);
  const [entries, setEntries] = useState([createEntry()]);
  const [updateData, setUpdateData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fileRef = useRef(null);
  const keys = [
    "Sr No.",
    "station_id",

    "item_id",
    "requested_date",
    "requested_qty",
    "remarks",

    "approved_qty",

    "issued_qty",
    "issued_date",
    "document",
    "status",
    "action",
  ];
  const inputStyle = {
    width: "110px",

    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const selectStyle = {
    width: "130px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const disabledStyle = {
    width: "110px",
    background: "#b7b2c0",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "not-allowed",
    fontSize: "0.8rem",
  };
  useEffect(() => {
    if (!userData || !stationData.length) return;

    const station = stationData.find(
      (item) => item.station_code === userData.stn,
    );

    if (station) {
      setStationId(station.station_id);
    }
  }, [userData, stationData]);

  const fetchData = async () => {
    if (!stationId) return;

    setLoading(true);
    setError(false);

    try {
      let url =
        stationId != 1
          ? `${urlPrefix}getDynamicDataForTwoDate?table_name=m_store_demand&station_id=${stationId}&status={"op":"NOT IN","value":["COMPLETED","PARTIALLY_ISSUED","REJECTED"]}
          `
          : `${urlPrefix}getDynamicDataForTwoDate?table_name=m_store_demand&status={"op":"NOT IN","value":["COMPLETED","PARTIALLY_ISSUED","REJECTED"]}`;

      const response = await axios.get(url);

      if (response.data.success) {
        const data = response.data.data || [];

        setUpdateData(data);

        setEntries(
          data.map((item) => ({
            ...item,
            isEdited: false,
          })),
        );
      } else {
        setUpdateData([]);
        setEntries([]);
      }
    } catch (err) {
      console.error("Failed to fetch data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stationId) {
      fetchData();
    }
  }, [stationId]);

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) =>
        i === rowIndex
          ? {
              ...row,
              [key]: value,
              isEdited: true,
            }
          : row,
      ),
    );
  };

  const handleSubmit = async (row, action) => {
    const PL = [row];
    if (action === "APPROVE") {
      const PayLoad = PL?.map((entry) => ({
        id: entry.id,
        approved_qty: entry.approved_qty,
        approved_by: userData.id,
      }));

      const approveRes = await fetch(
        `${urlPrefix}store/approve_demand

`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(PayLoad),
        },
      );

      if (!approveRes.ok) {
        const err = await approveRes.json();
        toast.error(err.message || "Update failed");
      }
      if (approveRes.ok) {
        toast.success("Saved successfully");
      }

      fetchData();
    }
    //////////////////////////////////
    if (action === "REJECT") {
      const PayLoad = PL?.map((entry) => ({
        id: entry.id,
        status: "REJECTED",
        approved_by: userData.id,
      }));

      const rejectRes = await fetch(
        `${urlPrefix}store/approve_demand

`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(PayLoad),
        },
      );

      if (!rejectRes.ok) {
        const err = await rejectRes.json();
        throw new Error(err.message || "Update failed");
      }
      toast.success("Saved successfully");
      fetchData();
    }
    //////////////////////////////////
    if (action === "ISSUE") {
      try {
        await Promise.all(
          PL.map(async (entry) => {
            const formdata = new FormData();

            formdata.append("id", String(entry.id));
            formdata.append("item_id", String(entry.item_id));
            formdata.append("transfer_qty", String(entry.issued_qty));
            formdata.append("issued_date", entry.issued_date || "");
            formdata.append("created_by", "3");

            if (entry.document instanceof File) {
              formdata.append("document", entry.document, entry.document.name);
            } else {
              formdata.append("document", "null");
            }

            const insertRes = await fetch(
              `${urlPrefix}store/issue_item_to_station`,
              {
                method: "POST",
                body: formdata,
                redirect: "follow",
              },
            );

            const result = await insertRes.json();

            if (!insertRes.ok) {
              throw new Error(result.message || "Failed to save");
            }

            toast.success(result.message || "Saved successfully");
            fetchData();

            return result;
          }),
        );
        setEntries([
          {
            document: null,
          },
        ]);
        if (fileRef.current) {
          fileRef.current.value = "";
        }
      } catch (err) {
        console.error("Demand insert error:", err);
        toast.error(err.message || "Failed to save demand");
      }
    }
    /////////////////////
  };

  return (
    <div
      className="  shadow p-0 rounded"
      style={{
        maxHeight: "800px",
        overflow: "auto",
        border: "8px solid #e1dde9",
      }}
    >
      {loading && <Loading />}
      <div
        className=" p-2 m-0 text-white  d-flex justify-content-center "
        style={{ background: "#5c5666" }}
      >
        <span
          className="btn btn-sm m-1 pt-1 fs-5 fw-semibold shadow-sm text-white rounded-3"
          style={{ background: "linear-gradient(135deg,#e85d04,#f48c06)" }}
        >
          Demand
        </span>
      </div>
      <div className="d-flex justify-content-center">
        <select
          className="form-select-sm shadow m-2"
          style={selectStyle}
          value={stationId}
          onChange={(e) => setStationId(Number(e.target.value))}
        >
          {/* <option>Select </option>{" "} */}
          <option>select</option>
          {userData.stn &&
            stationData

              // .filter((item) => item.station_code === userData.stn)
              .map((item) => (
                <option key={item.station_id} value={item.station_id}>
                  {item.station_code}
                </option>
              ))}
        </select>

        {/* //<button className="btn btn-dark btn-sm" onClick={addRow}> */}
        {/* Add Row */}
        {/* </button>//// */}
      </div>

      <div className="table-responsive" style={{ maxHeight: "600px" }}>
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead>
            <tr>
              {keys.map((key) => (
                <th
                  key={key}
                  style={{
                    background: "#d3cae6",
                    whiteSpace: "nowrap",
                    border: "none",
                  }}
                >
                  {key.replaceAll("_", " ").toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="    ">
            {entries.map((row, rowIndex) => {
              const statusStyle = {
                COMPLETED: {
                  background: "#d1f7c4",
                  color: "#176b2c",
                  icon: "✓",
                },
                PENDING: {
                  background: "#fff3cd",
                  color: "#856404",
                  icon: "⏳",
                },
                APPROVED: {
                  background: "#cfe2ff",
                  color: "#084298",
                  icon: "✓",
                },
                PARTIALLY_ISSUED: {
                  background: "#ffe0b2",
                  color: "#8a4b08",
                  icon: "⚠",
                },
                REJECTED: {
                  background: "#f8d7da",
                  color: "#842029",
                  icon: "✕",
                },
              };

              const status = statusStyle[row.status] || {
                background: "#eee",
                color: "#333",
                icon: "",
              };

              return (
                <React.Fragment key={rowIndex}>
                  <tr
                    onClick={() => setSelectedRow(rowIndex)}
                    style={{
                      cursor: "pointer",
                      border:
                        selectedRow === rowIndex ? "3px solid #b69bee" : "",
                    }}
                  >
                    {keys.map((key) => (
                      <td key={key} className="p-1 m-0">
                        {key === "Sr No." ? (
                          <div className=" fw-bold mt-1 ">{rowIndex + 1}</div>
                        ) : key === "action" ? (
                          // <button
                          //   className="btn btn-danger btn-sm"
                          //   onClick={() => removeRow(rowIndex)}
                          // >
                          //   &times;
                          // </button>

                          <div>
                            {row.status === "PENDING" && (
                              <button
                                className="btn btn-sm px-3 fw-semibold text-white shadow-sm rounded-pill"
                                style={{
                                  background:
                                    "linear-gradient(135deg,#6f42c1,#8e5de7)",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => handleSubmit(row, "APPROVE")}
                              >
                                Approve
                              </button>
                            )}

                            {row.status === "APPROVED" && (
                              <button
                                className="btn btn-sm px-3 fw-semibold text-white shadow-sm rounded-pill"
                                style={{
                                  background:
                                    "linear-gradient(135deg,#6f42c1,#8e5de7)",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => handleSubmit(row, "ISSUE")}
                              >
                                Issue
                              </button>
                            )}
                            {row.status === "PENDING" && (
                              <button
                                className="ms-2 btn btn-sm px-3 fw-semibold text-white shadow-sm rounded-pill"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #dc3545, #ff6b6b)",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => handleSubmit(row, "REJECT")}
                              >
                                Reject
                              </button>
                            )}
                          </div>
                        ) : key === "document" ? (
                          <div className="d-flex justify-content-center shadow">
                            <input
                              disabled={row.status !== "APPROVED"}
                              ref={fileRef}
                              style={{
                                ...(row.status !== "APPROVED"
                                  ? disabledStyle
                                  : inputStyle),
                                width: "220px",
                                background: "#e1dde9",
                                borderColor: row[key] ? "#d0c4e7" : "white",
                              }}
                              type="file"
                              accept=".pdf"
                              className={`form-control form-control-sm ${
                                row[key] ? "border-success" : "border-warning"
                              }`}
                              onChange={(e) => {
                                const f = e.target.files?.[0];

                                if (!f) return;

                                if (
                                  f.type !== "application/pdf" ||
                                  f.size > 500 * 1024
                                ) {
                                  return alert("Only PDF up to 500 KB allowed");
                                }

                                handleChange(rowIndex, key, f);
                              }}
                            />

                            {row[key] && (
                              <>
                                <button
                                  type="button"
                                  className="ms-3 btn btn-sm btn-primary rounded-pill"
                                  onClick={() =>
                                    window.open(
                                      typeof row[key] === "string"
                                        ? row[key]
                                        : URL.createObjectURL(row[key]),
                                      "_blank",
                                    )
                                  }
                                >
                                  📄
                                </button>
                              </>
                            )}

                            {!row[key] && (
                              <small className="text-muted mt-3">
                                Max 500 KB
                              </small>
                            )}
                          </div>
                        ) : key === "issued_date" ? (
                          <input
                            type="date"
                            disabled={
                              key === "issued_date" && row.status !== "APPROVED"
                            }
                            className="form-select-sm shadow"
                            style={
                              key === "issued_date" && row.status !== "APPROVED"
                                ? disabledStyle
                                : inputStyle
                            }
                            value={row[key] ? row[key].slice(0, 10) : ""}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          />
                        ) : key === "issued_qty" || key === "approved_qty" ? (
                          <input
                            type="number"
                            disabled={
                              key === "issued_qty" && row.status !== "APPROVED"
                            }
                            className="form-select-sm shadow"
                            style={
                              key === "issued_qty" && row.status !== "APPROVED"
                                ? disabledStyle
                                : inputStyle
                            }
                            value={row[key] ?? ""}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          />
                        ) : key === "status" ? (
                          <div
                            className=" px-3 py-2  mt-1 rounded-pill fw-bold"
                            style={{
                              background: status.background,
                              color: status.color,
                            }}
                          >
                            {status.icon} {row[key]}
                          </div>
                        ) : key === "station_id" ? (
                          <select
                            disabled
                            className="form-select shadow"
                            style={selectStyle}
                            value={row[key]}
                            onChange={(e) =>
                              handleChange(
                                rowIndex,
                                key,
                                Number(e.target.value),
                              )
                            }
                          >
                            <option value="">Select</option>

                            {stationData.map((item) => (
                              <option
                                key={item.station_id}
                                value={item.station_id}
                              >
                                {item.station_code}
                              </option>
                            ))}
                          </select>
                        ) : key === "item_id" ? (
                          <select
                            disabled
                            className="form-select shadow"
                            style={selectStyle}
                            value={row[key]}
                            onChange={(e) =>
                              handleChange(
                                rowIndex,
                                key,
                                Number(e.target.value),
                              )
                            }
                          >
                            <option value="">Select</option>

                            {itemData.map((item) => (
                              <option key={item.item_id} value={item.item_id}>
                                {item.item_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <div className=" d-flex justify-content-center">
                            <div
                              className=" p-1 shadow"
                              style={{
                                width: key === "remarks" ? "200px" : "110px",
                                background: "#e1dde9",
                                color: "#5c5666",
                                border: "2px solid #fafafa",
                                borderRadius: "10px",
                                fontWeight: "500",
                                cursor: "pointer",
                                fontSize: "0.8rem",
                                overflow: "hidden",
                              }}
                              value={row[key]}
                              onChange={(e) =>
                                handleChange(rowIndex, key, e.target.value)
                              }
                            >
                              {key === "requested_date"
                                ? row[key]?.slice(0, 10)
                                : row[key]}
                            </div>
                          </div>
                        )}
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DemandApprovalIns;
